module.exports = __webpack_public_path__ + "img/empty_comments.6fce0b9c.svg";